/* bf26y-r19.js (13 Oct 2026, r19). Go-live QA fixes. Rollback: delete the two r19 lines in snippets/bf26a-a11y.liquid.
   1 pack maths in every currency: the quantity-breaks block subtracts a fixed AUD amount (data-fixed-discount) from a converted price. Here the fixed amount becomes a share of the unit price (snapped to the nearest quarter, so 3 Pack = pay for 2, 2 Pack = 1.5 units) and the block's own methods redraw the labels, PDP price and offer prices. The discount is floored to a whole cent so the pack total rounds up exactly like the cart lines.
   2 copy leftovers (text and mailto links): orders@ and hello@ become support@, 'Next day dispatch', stray 2-6 / 2-8 day delivery times, wash bag size 30 x 40 cm and its 'fits 2 pairs' line.
   3 a sold-out selected variant always shows a disabled 'Sold out' add to cart (main button and sticky bar).
   4 one visible guarantee line per page (extra trust items that repeat it are removed). */
(function () {
  'use strict';
  var handle = (location.pathname.match(/^\/products\/([^\/?#]+)/) || [])[1];

  /* 1 */
  function fixPacks(el) {
    if (el.__bf26fx || !el.labels || !el.initOfferPrices) return;
    var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
    var base = parseFloat(el.dataset.basePrice);
    if (!base) return;
    el.__bf26fx = 1;
    var changed = 0;
    el.labels.forEach(function (l) {
      var fa = parseFloat(l.dataset.fixedDiscount) || 0;
      if (l.dataset.bf26fx || fa <= 0) return;
      l.dataset.fixedDiscount = String(Math.floor(Math.round(fa * rate / base * 4) / 4 * base));
      l.dataset.bf26fx = '1';
      changed++;
    });
    /* r53 (15 Oct 2026, W2): product templates now set the packs as a percentage (fixed amount 0), so Liquid prints the right
       numbers in every currency and nothing is rescaled here. Only redraw the labels when a fixed amount was rescaled
       (landing pages), so a product page is never re-rendered after first paint. */
    if (!changed) return;
    try { el.initOfferPrices(); if (el.updateInnerPrices) el.updateInnerPrices(); } catch (e) {}
  }
  function packs() { document.querySelectorAll('quantity-breaks').forEach(fixPacks); }

  /* 2 */
  var RULES = [
    [/\b(?:orders|hello)@rookakon\.com\b/g, 'support@rookakon.com'],
    [/\b2\s*(?:-|\u2013|to)\s*6 business days/g, '3-5 business days'],
    [/\b2\s*(?:-|\u2013|to)\s*8 business days/g, '7 to 10 days'],
    [/\b30\s*x\s*40\s*cm\b/gi, '20 x 30 cm'],
    [/fits 2 pairs? of gloves and 2 pairs? of socks/gi, 'fits a pair of gloves and a pair of socks']
  ];
  var KEY = /(orders@|hello@|business days|30\s*x\s*40|2 pairs? of gloves)/i;
  function copy() {
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, { acceptNode: function (n) {
      var p = n.parentNode && n.parentNode.nodeName;
      return (p === 'SCRIPT' || p === 'STYLE' || p === 'NOSCRIPT' || p === 'TEXTAREA') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
    } }), n, v, k;
    while ((n = w.nextNode())) {
      v = n.nodeValue;
      if (v.length < 8 || !KEY.test(v) || /typically arrive within 2/.test(v)) continue;
      for (k = 0; k < RULES.length; k++) v = v.replace(RULES[k][0], RULES[k][1]);
      if (v !== n.nodeValue) n.nodeValue = v;
    }
    document.querySelectorAll('a[href^="mailto:"]').forEach(function (a) {
      var h = a.getAttribute('href');
      if (/(orders|hello)@rookakon\.com/i.test(h)) a.setAttribute('href', h.replace(/(orders|hello)@rookakon\.com/ig, 'support@rookakon.com'));
    });
  }

  /* 3 */
  var prodP = null;
  function prodData() {
    if (!handle) return Promise.resolve(null);
    return prodP || (prodP = fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).catch(function () { return null; }));
  }
  function atcSold() {
    if (!handle) return;
    prodData().then(function (p) {
      if (!p) return;
      var f = document.querySelector('product-form input[name="id"], form[action*="/cart/add"] input[name="id"]');
      var vid = f ? Number(f.value) : 0, v = p.variants.filter(function (x) { return x.id === vid; })[0];
      var out = v ? !v.available : !p.available;
      document.querySelectorAll('.atc-button.product-form__submit, [data-satc-btn]').forEach(function (b) {
        if (b.closest('quick-add-modal, [role="dialog"], cart-drawer')) return;
        var t = b.querySelector('.main-atc__label__line-1 span') || (b.hasAttribute('data-satc-btn') ? b : null);
        if (!t) return;
        if (out) {
          if (b.__bf26so == null) b.__bf26so = t.textContent;
          if (!b.disabled) b.disabled = true;
          b.setAttribute('aria-disabled', 'true');
          if (!/sold out/i.test(t.textContent)) t.textContent = 'Sold out';
        } else if (b.__bf26so != null) {
          if (/sold out/i.test(t.textContent)) t.textContent = b.__bf26so;
          b.disabled = false; b.removeAttribute('aria-disabled'); b.__bf26so = null;
        }
      });
    });
  }

  /* 4 */
  function guarantee() {
    var seen = false;
    document.querySelectorAll('.bf26z-trust__item').forEach(function (li) {
      if (li.closest('cart-drawer, #CartDrawer') || !/money-back guarantee/i.test(li.textContent)) return;
      if (!seen) { seen = true; return; }
      li.remove();
    });
  }

  var t = 0;
  function all() { try { packs(); copy(); guarantee(); } catch (e) {} } /* 21 Oct 2026 (speed): atcSold() off, the buy buttons and sticky bar print the sold-out state on the server; it fetched the product on every page */
  function sched() { clearTimeout(t); t = setTimeout(all, 250); }
  function start() {
    all();
    customElements.whenDefined('quantity-breaks').then(packs);
    setTimeout(all, 1500); setTimeout(all, 4000);
    if (window.MutationObserver) new MutationObserver(function () { packs(); sched(); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
